export enum EDatabaseSyncStatus {
	upToDate,
	obsolete,
	synchronizing,
	error
}